import { Component, Input } from '@angular/core';
import {Instruction} from '../../models/instruction';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'instruction-slides',
  templateUrl: 'instruction-slides.html'
})
export class InstructionSlidesComponent {

  @Input('isDeviceBarcode') isDeviceBarcode : string;
  step1 : Instruction;
  step2 : Instruction;
  step3 : Instruction;
  step4 : Instruction;
  slides : Array<Instruction>;
  step1Barcode : Instruction;
  step2Barcode : Instruction;
  step3Barcode : Instruction;
  step4Barcode : Instruction;
  step5Barcode : Instruction;
  step6Barcode : Instruction;
  step7Barcode : Instruction;
  step8Barcode: Instruction;
  slidesBarcode : Array<Instruction>;

  constructor(private translate : TranslateService) {
  }
  ngOnInit(){
    this.step1 = {
      title : this.translate.instant('instructions.title'),
      step : this.translate.instant('instructions.step1'),
      instruction : this.translate.instant('instructions.instruction1'),
      iconName : 'power'
    };
    this.step2 = {
      title : this.translate.instant('instructions.title'),
      step : this.translate.instant('instructions.step2'),
      instruction : this.translate.instant('instructions.instruction2'),
      iconName : 'bluetooth'
    };
    this.step3 = {
      title : this.translate.instant('instructions.title'),
      step : this.translate.instant('instructions.step3'),
      instruction : this.translate.instant('instructions.instruction3'),
      iconName : 'barcode'
    };
    this.step4 = {
      title : this.translate.instant('instructions.title'),
      step : this.translate.instant('instructions.step4'),
      instruction : this.translate.instant('instructions.instruction4'),
      iconClass : 'tr_icon_reader'
    };

    this.slides = [this.step1,this.step2,this.step3,this.step4];
    this.step1Barcode = {
      title : this.translate.instant('instructions.titleSled'),
      step : this.translate.instant('instructions.step1'),
      instruction : this.translate.instant('instructions.instructionsBarcode.instruction1'),
      iconName : 'power'
    };

    this.step2Barcode = {
      title : this.translate.instant('instructions.titleSled'),
      step : this.translate.instant('instructions.step2'),
      instruction : this.translate.instant('instructions.instructionsBarcode.instruction2'),
      iconName : 'bluetooth'
    };
    this.step3Barcode = {
      title : this.translate.instant('instructions.titleSled'),
      step : this.translate.instant('instructions.step3'),
      instruction : this.translate.instant('instructions.instructionsBarcode.instruction3'),
      iconClass : 'tr_icon_step_3'
    };
    this.step4Barcode = {
      title : this.translate.instant('instructions.titleSled'),
      step : this.translate.instant('instructions.step4'),
      instruction : this.translate.instant('instructions.instructionsBarcode.instruction4'),
      iconClass : 'tr_icon_step_4'
    };
    this.step5Barcode = {
      title : this.translate.instant('instructions.titleSled'),
      step : this.translate.instant('instructions.step5'),
      instruction : this.translate.instant('instructions.instructionsBarcode.instruction5'),
      subInstruction : this.translate.instant('instructions.instructionsBarcode.instruction5a'),
      iconClass : 'tr_icon_step_5'
    };
    this.step6Barcode = {
      title : this.translate.instant('instructions.titleSled'),
      step : this.translate.instant('instructions.step6'),
      instruction : this.translate.instant('instructions.instructionsBarcode.instruction6'),
      iconClass : 'tr_icon_reader'
    };
    this.step7Barcode = {
      title : this.translate.instant('instructions.titleSled'),
      step : this.translate.instant('instructions.step7'),
      instruction : this.translate.instant('instructions.instructionsBarcode.instruction7'),
      iconClass : 'tr_icon_step_6'
    };
    this.step8Barcode = {
      title : this.translate.instant('instructions.titleSled'),
      step : this.translate.instant('instructions.step8'),
      instruction : this.translate.instant('instructions.instructionsBarcode.instruction8'),
      iconClass : 'tr_icon_step_8'
    };
    this.slidesBarcode = [this.step1Barcode,this.step2Barcode,this.step3Barcode,this.step4Barcode,this.step5Barcode,this.step6Barcode,this.step7Barcode,this.step8Barcode];
  }
}



// WEBPACK FOOTER //
// ./src/components/instruction-slides/instruction-slides.ts